import React from "react";
import { useIntl } from "react-intl";

import Div from "@components/Div";
import { H1, H4 } from "@components/Heading";
import GDPRInformationMessage from "@components/privacyPolicies/GDPRInformationMessage";

import ProgressSpinner from "@components/ProgressSpinner";

import { useCandidateConsentStep } from "./CandidateConsentStep.hooks";
import { OrderItemsCard, ProvideConsentCard } from "./components";

const CandidateConsentStep = () => {
  const { messages, formatMessage } = useIntl();
  const { handleUpdateConsent, isLoading, orderDetails } =
    useCandidateConsentStep();

  return (
    <Div
      position="absolute"
      top={-3}
      left={-3}
      right={0}
      bottom={0}
      bg="var(--site-background-color)"
      display="flex"
      flexDirection="column"
      justifyContent="space-between"
      gridGap={4}
      zIndex={1}
    >
      {isLoading && <ProgressSpinner />}

      <Div display="flex" flexDirection="column" gridGap={4}>
        <Div display="flex" gridGap="24px" flexDirection="column">
          <H1>{messages.title_welcome_to_candidate_portal}</H1>

          <H4>
            {formatMessage(
              { id: "subtitle_welcome_to_candidate_portal" },
              { companyName: orderDetails?.companyName }
            )}
          </H4>
        </Div>

        <Div display="flex" flexDirection="column" gridGap={3}>
          <ProvideConsentCard
            companyName={orderDetails?.companyName}
            expiresInDays={orderDetails?.expiresIn}
            consentStatus={orderDetails?.consentStatus}
            onProvideConsent={handleUpdateConsent}
          />

          <OrderItemsCard
            candidateName={orderDetails?.candidateName}
            companyName={orderDetails?.companyName}
            orderDate={orderDetails?.orderDate}
            products={orderDetails?.products}
          />
        </Div>
      </Div>

      <Div display="flex" flexDirection="column">
        <GDPRInformationMessage isCandidateConsentPage/>

        <Div height="32px" width={1}>
          &nbsp;
        </Div>
      </Div>
    </Div>
  );
};

export default CandidateConsentStep;
